import type { FC, ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { selectIsLoggedIn } from '../features/auth/selectors/authSelectors'
import { useAppSelector } from '../hooks'

interface ProtectedRouteProps {
  element: ReactElement
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ element }) => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  if (!isLoggedIn) {
    return <Navigate to="/" replace />
  }

  return element
}
